import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { PageStateContext } from '../../services';

export const MunchkinMarketo = () => {
  const { environment } = useContext(PageStateContext);

  return (
    <Helmet>
      <script type="text/javascript">
        {`
          var didInit = false;
          function initMunchkin() {
            if (didInit === false) {
              didInit = true;
              Munchkin.init('${environment.munchkinAccountId}', {"wsInfo": "j0hXcdjOKwML"});
            }
          }
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = '//munchkin.marketo.net/munchkin.js';
          s.onreadystatechange = function () {
            if (this.readyState == 'complete' || this.readyState == 'loaded') {
              initMunchkin();
            }
          };
          s.onload = initMunchkin;
          document.getElementsByTagName('head')[0].appendChild(s);
        `}
      </script>
    </Helmet>
  );
};
